<div class="card card-info">
    <div class="card-header">
        <h3 class="card-title">Organisations</h3>
    </div>

    <div class="card-body">
        <dx-data-grid [dataSource]="data"
                      [allowColumnReordering]="true"
                      [columnAutoWidth]="true"
                      [rowAlternationEnabled]="true"
                      [showRowLines]="true"
                      [showBorders]="true"
                      [remoteOperations]="false">
            <dxo-data-grid-filter-row [visible]="true"> </dxo-data-grid-filter-row>
            <dxo-data-grid-pager [showPageSizeSelector]="true"
                                 [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-data-grid-pager>
            <dxo-data-grid-paging [enabled]="true"
                                  [pageSize]="25"> </dxo-data-grid-paging>

            <!-- Columns -->
            <dxi-data-grid-column caption="Id"
                                  dataField="connectionId"
                                  dataType="number"> </dxi-data-grid-column>

            <dxi-data-grid-column caption="Organisation"
                                  dataField="organisation"
                                  dataType="string"
                                  cellTemplate="orgCellTemplate"> </dxi-data-grid-column>

            <dxi-data-grid-column caption="Type"
                                  dataField="connectionType"
                                  dataType="string"> </dxi-data-grid-column>

            <dxi-data-grid-column caption="Start Date"
                                  dataField="startDate"
                                  dataType="date"
                                  [format]="dateFormat"
                                  sortOrder="desc"> </dxi-data-grid-column>

            <dxi-data-grid-column caption="End Date"
                                  dataField="endDate"
                                  dataType="date"
                                  [format]="dateFormat"> </dxi-data-grid-column>

            <dxi-data-grid-column caption="Status"
                                  [calculateCellValue]="getIsActive"
                                  dataField="dummyIsActive"
                                  dataType="boolean"
                                  trueText="Active"
                                  falseText="Inactive"
                                  [filterValue]="true"> </dxi-data-grid-column>

            <dxi-data-grid-column caption="Has Platform Access"
                                  dataField="hasAccess"
                                  dataType="boolean"> </dxi-data-grid-column>

            <dxi-data-grid-column caption="Email Confirmed"
                                  [calculateCellValue]="getEmailConfirmed"
                                  dataField="dummyEmailConfirmed"
                                  dataType="boolean"> </dxi-data-grid-column>

            <dxi-data-grid-column caption="Last Access"
                                  [calculateCellValue]="getLastAccess"
                                  dataField="dummyLastAccess"
                                  dataType="date"
                                  [format]="dateFormat"> </dxi-data-grid-column>

            <!-- Templates -->
            <div *dxTemplate="let item of 'orgCellTemplate'">
                <adapt-link-organisation [organisation]="item.data.organisation"></adapt-link-organisation>
            </div>
        </dx-data-grid>
    </div>
</div>
